module.exports = __webpack_public_path__ + "media/assets/images/flags/mr-0dabe10364dcd64efd8dfe14692f9b1d.svg";